<div class="hero-section">
  <div class="hero-content">
    <h1>Equipment Rentals</h1>
    <p>Heavy machinery, generators, and job-site gear — rent what you need, when you need it.</p>
    <a href="https://alreadydone.us/#/equipment" target="_blank" rel="noopener" class="manage-equipment-link">
      <mat-icon>construction</mat-icon> Manage Equipment
    </a>
  </div>

  <div class="search-wrapper">
    <div class="search-container">
      <!-- Search row -->
      <div class="search-row">
        <input
          type="text"
          [formControl]="searchControl"
          placeholder="Search (e.g., excavator, generator)"
          aria-label="Search equipment"
          class="search-input"
        />
        <select [formControl]="categoryControl" (change)="applyFilters()" aria-label="Category" class="search-select">
          <option value="">All Categories</option>
          <option *ngFor="let cat of categories" [value]="cat.value">{{ cat.label }}</option>
        </select>
        <button mat-raised-button color="primary" (click)="applyFilters()" class="search-btn">
          <mat-icon>search</mat-icon> Search
        </button>
      </div>
      <!-- Quick filters -->
      <div class="quick-filters">
        <p class="qf-label">Popular:</p>
        <div class="qf-chips">
          <button mat-stroked-button *ngFor="let cat of categories | slice:0:6"
            (click)="categoryControl.setValue(cat.value); applyFilters()"
            class="qf-chip">{{ cat.label }}</button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Provider-as-customer error -->
<div *ngIf="rentalError" class="booking-alert-bar">
  <mat-icon>info</mat-icon>
  <span>{{ rentalError }}</span>
  <button type="button" (click)="rentalError = null">×</button>
</div>

<div class="page-body">
  <div class="page-inner">

    <!-- Filters bar -->
    <div class="filters-bar">
      <div class="filters-count">
        <span class="count-num">{{ filteredEquipment.length }}</span>
        <span class="count-of">of {{ equipment.length }} equipment</span>
      </div>
      <div class="filters-controls">
        <!-- Price Filter -->
        <div class="filter-control">
          <mat-icon class="filter-icon">attach_money</mat-icon>
          <select [(ngModel)]="priceFilter" (change)="applyFilters()" class="filter-select">
            <option value="all">All Rates</option>
            <option value="under100">&lt;$100/day</option>
            <option value="100to300">$100–$300/day</option>
            <option value="over300">&gt;$300/day</option>
          </select>
        </div>
        <!-- Rating Filter -->
        <div class="filter-control">
          <mat-icon class="filter-icon">star</mat-icon>
          <label class="filter-checkbox-label">
            <input type="checkbox"
              (change)="minRating = minRating === 4 ? 0 : 4; applyFilters()"
              [checked]="minRating >= 4">
            4+ Stars
          </label>
        </div>
        <!-- Sort -->
        <div class="filter-control">
          <mat-icon class="filter-icon">sort</mat-icon>
          <select [(ngModel)]="sortBy" (change)="sortEquipment()" class="filter-select">
            <option value="relevance">Relevance</option>
            <option value="price-low">Low → High</option>
            <option value="price-high">High → Low</option>
            <option value="rating">Top Rated</option>
          </select>
        </div>
        <button mat-stroked-button (click)="resetFilters()" class="reset-btn">
          <mat-icon>restart_alt</mat-icon> Reset
        </button>
      </div>
    </div>

    <!-- Loading State -->
    <div *ngIf="loading" class="state-center">
      <div class="css-loading-spinner"></div>
      <p>Loading equipment…</p>
    </div>

    <!-- Empty State -->
    <div *ngIf="!loading && filteredEquipment.length === 0" class="empty-state">
      <mat-icon>search_off</mat-icon>
      <h3>No Equipment Found</h3>
      <p>Try adjusting your filters or searching a different term.</p>
      <button mat-raised-button color="primary" (click)="resetFilters()">
        <mat-icon>restart_alt</mat-icon> Reset Filters
      </button>
    </div>

    <!-- Equipment Grid -->
    <div class="services-grid" *ngIf="!loading && filteredEquipment.length > 0">
      <article class="svc-card" *ngFor="let e of filteredEquipment">

        <!-- Image -->
        <div class="svc-img-wrap">
          <img [src]="e.imageUrl" [alt]="e.name" class="svc-img"
               onerror="this.onerror=null; this.src='data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%27300%27 height=%27200%27%3E%3Crect width=%27100%25%27 height=%27100%25%27 fill=%27%23e2e8f0%27/%3E%3Ctext x=%2750%25%27 y=%2750%25%27 font-family=%27sans-serif%27 font-size=%2718%27 fill=%27%23718096%27 text-anchor=%27middle%27 dominant-baseline=%27middle%27%3EEquipment%3C/text%3E%3C/svg%3E'">
        </div>

        <!-- Content -->
        <div class="svc-body">
          <div class="svc-top">
            <h3 class="svc-title">{{ e.name }}</h3>
            <div class="svc-price-row">
              <span class="svc-price">${{ e.dailyRate | number }}</span>
              <span class="svc-price-label">/ day</span>
              <span class="svc-category">{{ e.category | titlecase }}</span>
            </div>
            <div class="svc-rating">
              <mat-icon class="star-icon">star</mat-icon>
              <span class="rating-val">{{ e.rating | number:'1.1-1' }}</span>
            </div>
            <p class="svc-desc">{{ e.description.length > 80 ? (e.description | slice:0:80) + '…' : e.description }}</p>
          </div>

          <div class="svc-footer">
            <div class="svc-provider">
              <div class="provider-avatar">{{ e.provider?.charAt(0) | uppercase }}</div>
              <span class="provider-name">{{ e.provider }}</span>
            </div>
            <button mat-raised-button color="primary" class="book-btn"
                    (click)="rentEquipment(e, $event)">
              <mat-icon>event_available</mat-icon> Rent
            </button>
          </div>
        </div>

      </article>
    </div>

    <!-- Pagination -->
    <div *ngIf="totalPages > 1" class="pagination">
      <button mat-stroked-button *ngFor="let p of [].constructor(totalPages); let i = index"
              [color]="page === i + 1 ? 'primary' : ''"
              (click)="changePage(i + 1)">
        {{ i + 1 }}
      </button>
    </div>

  </div>
</div>

<!-- ── Rental Request Modal ── -->
<div class="booking-overlay" *ngIf="showRentalModal" (click)="closeModal()">
  <div class="booking-modal" (click)="$event.stopPropagation()">

    <div *ngIf="rentalSuccess" class="booking-success">
      <div class="success-icon"><mat-icon>check_circle</mat-icon></div>
      <h2>Rental Requested!</h2>
      <p>Your request for <strong>{{ selectedEquipment?.name }}</strong> has been sent to <strong>{{ selectedEquipment?.provider }}</strong>. You'll receive confirmation shortly.</p>
      <button mat-raised-button color="primary" (click)="closeModal()">Done</button>
    </div>

    <ng-container *ngIf="!rentalSuccess">
      <div class="booking-modal-header">
        <div>
          <h2 class="booking-modal-title">Request a Rental</h2>
          <p class="booking-modal-sub">{{ selectedEquipment?.name }}</p>
        </div>
        <button mat-icon-button (click)="closeModal()"><mat-icon>close</mat-icon></button>
      </div>

      <form [formGroup]="rentalForm" (ngSubmit)="submitRental()" class="booking-form">

        <p class="step-question">When do you need it?</p>
        <div class="booking-two-col">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Start Date</mat-label>
            <input matInput type="date" formControlName="startDate" [min]="minDate" />
            <mat-error>Start date is required</mat-error>
          </mat-form-field>
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>End Date</mat-label>
            <input matInput type="date" formControlName="endDate" [min]="rentalForm.value.startDate || minDate" />
            <mat-error>End date is required</mat-error>
          </mat-form-field>
        </div>

        <p class="step-question">Where should it be delivered?</p>
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Delivery Address</mat-label>
          <textarea matInput formControlName="deliveryAddress" rows="2"
                    placeholder="Where should the equipment be delivered?"></textarea>
          <mat-error>Address is required</mat-error>
        </mat-form-field>
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Notes (optional)</mat-label>
          <textarea matInput formControlName="notes" rows="2"
                    placeholder="Any special requirements?"></textarea>
        </mat-form-field>

        <div class="review-card" *ngIf="rentalDays > 0">
          <div class="review-row"><span>Duration</span><strong>{{ rentalDays }} day{{ rentalDays === 1 ? '' : 's' }}</strong></div>
          <div class="review-row"><span>Daily Rate</span><strong>{{ selectedEquipment?.dailyRate | currency }}</strong></div>
          <div class="review-row"><span>Estimated Total</span><strong class="price-highlight">{{ estimatedTotal | currency }}</strong></div>
        </div>

        <div class="booking-form-actions">
          <button type="button" mat-stroked-button [disabled]="isSubmitting" (click)="closeModal()">
            Cancel
          </button>
          <button type="submit" mat-raised-button color="primary" [disabled]="isSubmitting || rentalDays <= 0">
            <mat-icon>event_available</mat-icon>
            {{ isSubmitting ? 'Submitting…' : 'Confirm Rental' }}
          </button>
        </div>
      </form>
    </ng-container>
  </div>
</div>
